var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _g, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccessImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 237,
    height: 99,
    viewBox: "0 0 237 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.244 92.8504L227.905 31.3965C222.852 30.3882 218.231 83.2927 218.231 83.2927C218.231 83.2927 221.579 20.281 216.459 20.281C216.454 20.281 216.45 20.2834 216.445 20.2834L217.548 92.8366L218.244 92.8504Z",
    fill: "#9DADEC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.165 92.8893L232.508 52.3724C229.31 52.1926 225.173 68.0354 223.246 76.2508C222.598 79.2168 222.17 81.0569 222.17 81.0569C222.17 81.0569 222.573 79.1191 223.246 76.2508C225.839 64.3813 231.955 34.4185 228.297 31.5778L218.663 92.859L220.165 92.8893Z",
    fill: "#9DADEC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M223.3 76.2506C222.593 79.1189 222.17 81.0572 222.17 81.0572C222.17 81.0572 222.62 79.2167 223.3 76.2506Z",
    fill: "#9DADEC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.973 92.9254C221.973 92.9254 237.334 55.217 233.001 52.5295C232.972 52.511 232.941 52.5005 232.912 52.4849L220.601 92.8974L221.973 92.9254Z",
    fill: "#9DADEC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M215.474 92.7948L216.187 92.8091L203.24 39.5221C199.2 41.3845 215.474 92.7948 215.474 92.7948Z",
    fill: "#9DADEC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.135 92.8282L216.035 20.4438C211.577 23.9076 215.474 83.2928 215.474 83.2928C215.474 83.2928 207.893 40.6269 203.66 39.4857L216.618 92.8182L217.135 92.8282Z",
    fill: "#9DADEC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M216.618 92.8179L203.66 39.4859C203.524 39.4493 203.392 39.4546 203.264 39.5063C203.255 39.5096 203.248 39.5177 203.239 39.5219L216.187 92.8089L216.618 92.8179Z",
    fill: "#607ED5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.548 92.8365L216.446 20.2837C216.301 20.287 216.165 20.343 216.035 20.4441L217.135 92.8279L217.548 92.8365Z",
    fill: "#607ED5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.663 92.8587L228.297 31.578C228.227 31.5234 228.155 31.4783 228.078 31.4437C228.02 31.4186 227.963 31.4081 227.905 31.3967L218.245 92.8502L218.663 92.8587Z",
    fill: "#607ED5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.6 92.8977L232.911 52.4851C232.779 52.4173 232.644 52.3798 232.508 52.3727L220.166 92.8891L220.6 92.8977Z",
    fill: "#607ED5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.8093 81.6089C29.0499 82.2094 29.1865 82.5259 29.1865 82.5259C29.1865 82.5259 29.06 82.1965 28.8093 81.6089Z",
    fill: "#577BC2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M199.8 82.0325L201.998 93.1466H203.087L209.476 43.2793C198.276 56.2358 198.821 73.9553 199.8 82.0325Z",
    fill: "#4060A9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.703 59.2128L201.062 93.1466H201.575L199.15 80.8866C197.231 74.5232 192.989 64.2562 184.703 59.2128Z",
    fill: "#4060A9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M198.142 93.1465H200.589L184.36 59.4822C184.526 85.5489 198.142 93.1465 198.142 93.1465Z",
    fill: "#4060A9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M210.943 93.1465C210.943 93.1465 222.083 87.1802 227.195 67.3132L209.117 93.1465H210.943Z",
    fill: "#4060A9"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.198 82.7461L207.815 93.1465H208.587L227.106 66.6841C218.303 69.8423 213.46 77.7659 211.198 82.7461Z",
    fill: "#4060A9"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209.823 43.8358L203.504 93.1465H207.373L210.762 82.73C212.629 75.0517 215.466 58.4412 209.823 43.8358Z",
    fill: "#4060A9"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.356 59.0034C184.356 59.1647 184.359 59.3223 184.36 59.4822L200.589 93.1465H201.061L184.703 59.2127C184.588 59.1429 184.473 59.0717 184.356 59.0034Z",
    fill: "#577BC2"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209.564 43.175C209.534 43.2097 209.506 43.2443 209.476 43.2794L203.087 93.1463H203.505L209.823 43.836C209.738 43.6154 209.653 43.3947 209.564 43.175Z",
    fill: "#577BC2"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.106 66.6842L208.587 93.1466H209.118L227.195 67.3129C227.259 67.0671 227.325 66.8284 227.387 66.5779C227.291 66.6111 227.2 66.65 227.106 66.6842Z",
    fill: "#577BC2"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.272 85.1918C200.434 85.9377 200.505 86.3633 200.505 86.3633C200.505 86.3633 200.409 85.9486 200.272 85.1918C200.063 84.2252 199.703 82.7183 199.15 80.8867L201.574 93.1467H201.998L199.8 82.0326C199.963 83.3735 200.137 84.4483 200.272 85.1918Z",
    fill: "#577BC2"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.428 85.1918C200.803 86.0296 201.065 86.4887 201.065 86.4887C201.065 86.4887 200.87 86.0175 200.428 85.1918Z",
    fill: "#577BC2"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209.826 86.2052C209.662 86.7494 209.564 87.0417 209.564 87.0417C209.564 87.0417 209.649 86.7338 209.826 86.2052C210.046 85.474 210.384 84.2839 210.762 82.73L207.373 93.1465H207.815L211.198 82.7461C210.523 84.2318 210.078 85.4502 209.826 86.2052Z",
    fill: "#577BC2"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M210.411 86.2052C209.929 87.0247 209.696 87.5021 209.696 87.5021C209.696 87.5021 209.964 87.049 210.411 86.2052Z",
    fill: "#577BC2"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2548 92.8504L6.59398 31.3965C11.6473 30.3882 16.268 83.2927 16.268 83.2927C16.268 83.2927 12.9202 20.281 18.0405 20.281C18.045 20.281 18.0492 20.2834 18.0537 20.2834L16.9511 92.8366L16.2548 92.8504Z",
    fill: "#9DADEC"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3337 92.8893L1.99127 52.3724C5.1895 52.1926 9.32583 68.0354 11.2529 76.2508C11.9009 79.2168 12.3294 81.0569 12.3294 81.0569C12.3294 81.0569 11.9257 79.1191 11.2529 76.2508C8.66048 64.3813 2.5438 34.4185 6.2024 31.5778L15.8359 92.859L14.3337 92.8893Z",
    fill: "#9DADEC"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1995 76.2506C11.9057 79.1189 12.3291 81.0572 12.3291 81.0572C12.3291 81.0572 11.8793 79.2167 11.1995 76.2506Z",
    fill: "#9DADEC"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.526 92.9254C12.526 92.9254 -2.83493 55.217 1.49771 52.5295C1.52746 52.511 1.55763 52.5005 1.58738 52.4849L13.8984 92.8974L12.526 92.9254Z",
    fill: "#9DADEC"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0248 92.7948L18.3115 92.8091L31.2594 39.5221C35.299 41.3845 19.0248 92.7948 19.0248 92.7948Z",
    fill: "#9DADEC"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3641 92.8282L18.4642 20.4438C22.9221 23.9076 19.025 83.2928 19.025 83.2928C19.025 83.2928 26.6063 40.6269 30.8394 39.4857L17.8807 92.8182L17.3641 92.8282Z",
    fill: "#9DADEC"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8808 92.8179L30.8395 39.4859C30.975 39.4493 31.1069 39.4546 31.235 39.5063C31.2441 39.5096 31.2511 39.5177 31.2598 39.5219L18.3119 92.8089L17.8808 92.8179Z",
    fill: "#607ED5"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9506 92.8365L18.0532 20.2837C18.1978 20.287 18.3342 20.343 18.4644 20.4441L17.3638 92.8279L16.9506 92.8365Z",
    fill: "#607ED5"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8358 92.8587L6.20181 31.578C6.27166 31.5234 6.34439 31.4783 6.42126 31.4437C6.4787 31.4186 6.53614 31.4081 6.59359 31.3967L16.2544 92.8502L15.8358 92.8587Z",
    fill: "#607ED5"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8987 92.8977L1.58769 52.4851C1.72035 52.4173 1.85466 52.3798 1.99103 52.3727L14.3335 92.8891L13.8987 92.8977Z",
    fill: "#607ED5"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M205.69 81.6089C205.449 82.2094 205.312 82.5259 205.312 82.5259C205.312 82.5259 205.439 82.1965 205.69 81.6089Z",
    fill: "#577BC2"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6988 82.0325L32.5014 93.1466H31.4125L25.0227 43.2793C36.2229 56.2358 35.6782 73.9553 34.6988 82.0325Z",
    fill: "#4060A9"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.7959 59.2128L33.4374 93.1466H32.9245L35.3487 80.8866C37.2683 74.5232 41.5096 64.2562 49.7959 59.2128Z",
    fill: "#4060A9"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.3572 93.1465H33.9099L50.1387 59.4822C49.9725 85.5489 36.3572 93.1465 36.3572 93.1465Z",
    fill: "#4060A9"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5565 93.1465C23.5565 93.1465 12.4162 87.1802 7.30372 67.3132L25.3818 93.1465H23.5565Z",
    fill: "#4060A9"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3011 82.7461L26.6841 93.1465H25.9117L7.39346 66.6841C16.1963 69.8423 21.0393 77.7659 23.3011 82.7461Z",
    fill: "#4060A9"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6759 43.8358L30.9946 93.1465H27.1257L23.7369 82.73C21.8702 75.0517 19.0332 58.4412 24.6759 43.8358Z",
    fill: "#4060A9"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.1426 59.0034C50.1426 59.1647 50.1397 59.3223 50.1389 59.4822L33.9101 93.1465H33.4377L49.7963 59.2127C49.9112 59.1429 50.0256 59.0717 50.1426 59.0034Z",
    fill: "#577BC2"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9347 43.175C24.9648 43.2097 24.9929 43.2443 25.0227 43.2794L31.4121 93.1463H30.9943L24.676 43.836C24.7611 43.6154 24.8458 43.3947 24.9347 43.175Z",
    fill: "#577BC2"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.39338 66.6842L25.9116 93.1466H25.3814L7.3037 67.3129C7.24006 67.0671 7.17353 66.8284 7.11195 66.5779C7.20783 66.6111 7.29874 66.65 7.39338 66.6842Z",
    fill: "#577BC2"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.227 85.1918C34.0655 85.9377 33.994 86.3633 33.994 86.3633C33.994 86.3633 34.0898 85.9486 34.227 85.1918C34.4357 84.2252 34.7965 82.7183 35.3486 80.8867L32.9249 93.1467H32.5013L34.6986 82.0326C34.5362 83.3735 34.3618 84.4483 34.227 85.1918Z",
    fill: "#577BC2"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0711 85.1918C33.6961 86.0296 33.4341 86.4887 33.4341 86.4887C33.4341 86.4887 33.6295 86.0175 34.0711 85.1918Z",
    fill: "#577BC2"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6733 86.2052C24.8369 86.7494 24.9349 87.0417 24.9349 87.0417C24.9349 87.0417 24.8497 86.7338 24.6733 86.2052C24.4534 85.474 24.1154 84.2839 23.7372 82.73L27.126 93.1465H26.6842L23.3012 82.7461C23.9761 84.2318 24.4212 85.4502 24.6733 86.2052Z",
    fill: "#577BC2"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.088 86.2052C24.5703 87.0247 24.803 87.5021 24.803 87.5021C24.803 87.5021 24.5353 87.049 24.088 86.2052Z",
    fill: "#577BC2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_909_45034",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 79,
    width: 237,
    height: 20
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 79.2129H236.045V98.0246H0V79.2129Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_909_45034)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.022 79.2129C34.9615 79.2129 0 92.4579 0 92.4579C0 92.4579 34.9615 98.0246 118.022 98.0246C201.083 98.0246 236.045 92.4579 236.045 92.4579C236.045 92.4579 201.083 79.2129 118.022 79.2129Z",
    fill: "#CFE6FD"
  }))), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M158.887 0.116943L103.989 35.8634L131.438 53.1019L158.887 0.116943Z",
    fill: "#CFE6FD"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7585 19.7881L158.887 0.116943L96.2794 29.9409L78.7585 19.7881Z",
    fill: "#CFE6FD"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M158.887 0.116943L96.2794 29.9409L99.9004 53.1019L103.989 35.8634L158.887 0.116943Z",
    fill: "#9DADEC"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9003 53.1019L112.669 41.3147L103.988 35.8634L99.9003 53.1019Z",
    fill: "#4060A9"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M131.438 53.1018L127.583 20.7341L103.989 35.8633L131.438 53.1018Z",
    fill: "#E5F2FF"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M123.32 17.0599L78.7587 19.788L96.2796 29.9409L123.32 17.0599Z",
    fill: "#E5F2FF"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.0857 63.3705C84.7731 63.0561 84.8 62.5405 85.1436 62.2603L94.71 54.4614C95.0089 54.2177 95.4438 54.2404 95.7157 54.5138L96.2638 55.0649C96.5765 55.3793 96.5496 55.8949 96.2059 56.1751L86.6395 63.974C86.3406 64.2177 85.9057 64.195 85.6338 63.9216L85.0857 63.3705Z",
    fill: "#4060A9"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.521 58.5193C103.209 58.2049 103.236 57.6893 103.579 57.4091L110.76 51.5549C111.059 51.3113 111.494 51.334 111.766 51.6074L112.314 52.1585C112.627 52.4729 112.6 52.9885 112.256 53.2686L105.075 59.1228C104.776 59.3665 104.341 59.3438 104.069 59.0704L103.521 58.5193Z",
    fill: "#4060A9"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.6736 50.7726C84.361 50.4582 84.3878 49.9426 84.7315 49.6624L91.9124 43.8082C92.2113 43.5646 92.6462 43.5872 92.9181 43.8607L93.4662 44.4118C93.7789 44.7262 93.752 45.2417 93.4083 45.5219L86.2274 51.3761C85.9285 51.6198 85.4936 51.5971 85.2217 51.3237L84.6736 50.7726Z",
    fill: "#4060A9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessImg);
export default __webpack_public_path__ + "static/media/success_img.7a525d5f28b39141c00cd965ce011e06.svg";
export { ForwardRef as ReactComponent };